<template>
	<!-- 404 page -->
	<Layout>
		<div class="account-pages mt-5 mb-5">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-lg-5">
						<div class="card">
							<div
								class="card-header pt-4 pb-4 text-center bg-primary"
							>
								<router-link tag="a" to="/">
									<span>
										<img
											class="white-filter"
											src="@/assets/images/logo.svg"
											alt="Lalamove logo"
											height="36"
										/>
									</span>
								</router-link>
							</div>

							<div class="card-body p-4">
								<div class="text-center">
									<h1 class="text-error">
										4
										<i class="mdi mdi-emoticon-sad" />
										4
									</h1>
									<h4 class="text-uppercase text-danger mt-3">
										{{ $t('PORTAL.NotFound.heading') }}
									</h4>
									<p class="text-muted mt-3">
										{{ $t('PORTAL.NotFound.text') }}
									</p>

									<router-link
										tag="a"
										class="btn btn-primary mt-3"
										to="/"
									>
										<i class="mdi mdi-home" />
										{{
											$t(
												'PORTAL.NotFound.button_return_home'
											)
										}}
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/views/layouts/Default.vue'

export default {
	page: {
		title: '404',
		meta: [{ name: 'description', content: 'Page Not Found' }]
	},
	components: { Layout }
}
</script>
